import useSWR from 'swr'

export const useFootPrinterBySWR = (ditto, body, interval = 0) => {
  const { userId } = body
  const { data, mutate } = useSWR(
    ['userFootPrint', body],
    (_, params) => {
      return userId ? ditto.fetchFootPrinter(params) : null
    },
    { refreshInterval: interval, revalidateOnFocus: false }
  )
  return {
    footPrinterData: data,
    footPrinterMutate: mutate,
  }
}

export const useUserStatusBySWR = (ditto, body, interval = 0) => {
  const { data, mutate } = useSWR(
    ['userStatus', body],
    (_, params) => ditto.fetchUserStatus(params),
    { dedupingInterval: 0, refreshInterval: interval }
  )
  return {
    userStatusData: data ? data.data : null,
    userStatusMutate: mutate,
  }
}
